<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';
import Button from 'dashboard/components-next/button/Button.vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import GgFollowupButton from 'dashboard/components-next/gg-followup/GgFollowupButton.vue';
import GgSupportButton from 'dashboard/components-next/gg-support/GgSupportButton.vue';
import wootConstants from 'dashboard/constants/globals';

defineProps({
  conversationId: { type: Number, required: true },
});

const emit = defineEmits(['close']);
const panel = ref(null);
const { width } = useWindowSize();
let opener;

const closeOnSmallScreen = () => {
  if (width.value < wootConstants.SMALL_SCREEN_BREAKPOINT) emit('close');
};

useKeyboardEvents({ Escape: { action: () => emit('close') } });

onMounted(() => {
  opener = document.activeElement;
  panel.value.focus();
});

onBeforeUnmount(() => {
  if (panel.value.contains(document.activeElement)) opener?.focus();
});
</script>

<template>
  <aside
    id="conversation-actions-panel"
    ref="panel"
    v-on-click-outside="[
      closeOnSmallScreen,
      { ignore: ['[data-conversation-panel-switch]'] },
    ]"
    aria-labelledby="conversation-actions-title"
    tabindex="-1"
    class="bg-n-background h-full overflow-hidden flex flex-col fixed top-0 end-0 z-40 w-full max-w-sm md:static md:w-[23rem] md:min-w-[23rem] border-s border-n-weak 2xl:w-[26rem] 2xl:min-w-[26rem] shadow-lg md:shadow-none outline-none"
  >
    <header
      class="flex items-center justify-between px-4 py-2 border-b border-n-weak h-12 shrink-0"
    >
      <h2
        id="conversation-actions-title"
        class="m-0 font-medium text-sm text-n-slate-12"
      >
        {{ $t('CONVERSATION_ACTIONS_PANEL.TITLE') }}
      </h2>
      <Button
        ghost
        sm
        icon="i-lucide-x"
        :aria-label="$t('CONVERSATION_ACTIONS_PANEL.CLOSE')"
        @click="emit('close')"
      />
    </header>
    <div class="flex-1 overflow-y-auto p-4">
      <div
        class="flex flex-col gap-2 rounded-lg border border-n-weak bg-n-solid-1 p-2"
      >
        <GgFollowupButton
          :conversation-id="conversationId"
          menu
          @selected="emit('close')"
        />
        <GgSupportButton
          :conversation-id="conversationId"
          menu
          @selected="emit('close')"
        />
      </div>
    </div>
  </aside>
</template>
